/**
 * Append Shopify's CDN `width` param so we serve a right-sized variant instead
 * of the full-resolution original (style samples can be ~1.5–3 MB each, which
 * tanks mobile LCP). Only cdn.shopify.com URLs are rewritten — anything else
 * (data URLs, other hosts, bridge URLs) is returned unchanged.
 */
export function shopifyImg(url: string | undefined | null, width: number): string {
  if (!url) return '';
  if (!url.includes('cdn.shopify.com')) return url;
  try {
    const u = new URL(url);
    u.searchParams.set('width', String(width));
    return u.toString();
  } catch {
    return url;
  }
}
